/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Ops_Desc3Inputs */

const en_svc_automation_ops_desc3 = /** @type {(inputs: Svc_Automation_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerts on failure, not silent breakage, every run is observable, retryable, and auditable.`)
};

const ar_svc_automation_ops_desc3 = /** @type {(inputs: Svc_Automation_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنبيهات عند الفشل لا انكسار صامت, كل تشغيل قابل للمراقبة وإعادة المحاولة والتدقيق.`)
};

const bn_svc_automation_ops_desc3 = /** @type {(inputs: Svc_Automation_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নীরব ব্রেকেজ নয়, ব্যর্থতায় অ্যালার্ট, প্রতিটি রান পর্যবেক্ষণ করা যায়, পুনরায় চালানো যায় ও অডিট করা যায়।`)
};

const de_svc_automation_ops_desc3 = /** @type {(inputs: Svc_Automation_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warnungen bei Fehlern, nicht bei stillschweigendem Ausfall; jeder Lauf ist beobachtbar, wiederholbar und überprüfbar.`)
};

const es_svc_automation_ops_desc3 = /** @type {(inputs: Svc_Automation_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas en caso de falla, no roturas silenciosas, cada ejecución es observable, con reintentos y auditable.`)
};

const fr_svc_automation_ops_desc3 = /** @type {(inputs: Svc_Automation_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertes en cas d'échec, pas de rupture silencieuse, chaque exécution est observable, relançable et auditable.`)
};

const pt_svc_automation_ops_desc3 = /** @type {(inputs: Svc_Automation_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas sobre falha, não sobre quebra silenciosa, cada execução é observável, com retry e auditável.`)
};

const zh_svc_automation_ops_desc3 = /** @type {(inputs: Svc_Automation_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败警报，而不是静默破坏，每次运行都是可观察、可重试和可审核的。`)
};

const tr_svc_automation_ops_desc3 = /** @type {(inputs: Svc_Automation_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessizce bozulmak yerine hatalarda uyarı verir; her çalışma izlenebilir, yeniden denenebilir ve denetlenebilir.`)
};

const ru_svc_automation_ops_desc3 = /** @type {(inputs: Svc_Automation_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оповещения о сбое, а не о тихой поломке, каждый запуск доступен для наблюдения, повторной попытки и проверки.`)
};

const pl_svc_automation_ops_desc3 = /** @type {(inputs: Svc_Automation_Ops_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerty przy awarii, nie ciche padanie, każdy run jest obserwowalny, retryowalny i audytowalny.`)
};

/**
* | output |
* | --- |
* | "Alerts on failure, not silent breakage, every run is observable, retryable, and auditable." |
*
* @param {Svc_Automation_Ops_Desc3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_ops_desc3 = /** @type {((inputs?: Svc_Automation_Ops_Desc3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Ops_Desc3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_ops_desc3(inputs)
	if (locale === "bn") return bn_svc_automation_ops_desc3(inputs)
	if (locale === "de") return de_svc_automation_ops_desc3(inputs)
	if (locale === "es") return es_svc_automation_ops_desc3(inputs)
	if (locale === "fr") return fr_svc_automation_ops_desc3(inputs)
	if (locale === "pt") return pt_svc_automation_ops_desc3(inputs)
	if (locale === "zh") return zh_svc_automation_ops_desc3(inputs)
	if (locale === "tr") return tr_svc_automation_ops_desc3(inputs)
	if (locale === "ru") return ru_svc_automation_ops_desc3(inputs)
	if (locale === "pl") return pl_svc_automation_ops_desc3(inputs)
	return en_svc_automation_ops_desc3(inputs)
});
export { svc_automation_ops_desc3 as "svc_automation_OPS_desc" }